import React from 'react';

import Icon from '@ant-design/icons';

const ImportSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2.4rem"
    height="2.4rem"
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit="2"
    clipRule="evenodd"
    id="import"
    fill="currentColor"
  >
    <path d="m 12.414,15 1.293,1.293 c 0.39,0.39 0.39,1.024 0,1.414 -0.39,0.39 -1.024,0.39 -1.414,0 l -3,-3 c -0.391,-0.39 -0.391,-1.024 0,-1.414 l 3,-3 c 0.39,-0.39 1.024,-0.39 1.414,0 0.39,0.39 0.39,1.024 0,1.414 L 12.414,13 H 18 c 0.53,0 1.039,0.211 1.414,0.586 C 19.789,13.961 20,14.47 20,15 c 0,1.281 0,2.902 0,4 0,1.657 -1.343,3 -3,3 H 5 C 4.448,22 4,21.552 4,21 4,21 4,9.69 4,5 4,4.204 4.316,3.441 4.879,2.879 5.441,2.316 6.204,2 7,2 c 2.223,0 5.726,0 7.459,0 0.979,0 1.896,0.478 2.457,1.28 0.73,1.042 1.941,2.771 2.542,3.63 C 19.811,7.414 20,8.015 20,8.63 V 10 c 0,0.552 -0.448,1 -1,1 -0.552,0 -1,-0.448 -1,-1 0,0 0,-0.783 0,-1.37 C 18,8.425 17.937,8.225 17.819,8.057 17.218,7.198 16.007,5.469 15.278,4.427 15.091,4.159 14.785,4 14.459,4 12.726,4 9.223,4 7,4 6.735,4 6.48,4.105 6.293,4.293 6.105,4.48 6,4.735 6,5 v 15 h 11 c 0.552,0 1,-0.448 1,-1 v -4 z"></path>
  </svg>
);
const ImportIcon = props => {
  return <Icon component={ImportSvg} {...props} style={{ color: '#009383' }} />;
};
export default ImportIcon;
